/*
 * @Author: your name
 * @Date: 2020-10-22 14:02:44
 * @LastEditTime: 2021-11-24 16:08:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ksh-factory-vue/src/store/mutations-types.js
 */

// 页面状态
export const REQUEST_DOING = 'REQUEST_DOING'
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS'
export const REQUEST_FAILED = 'REQUEST_FAILED'
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE'
// 用户权限
export const GET_INDEX_DEMAND_LIST = 'GET_INDEX_DEMAND_LIST'
export const GET_SEARCH_DEMAND_LIST = 'GET_SEARCH_DEMAND_LIST'
export const GET_DIC_OPTION_LIST = 'GET_DIC_OPTION_LIST'
export const GET_AREA_LIST = 'GET_AREA_LIST'
